export default __webpack_public_path__ + "static/media/leggings_of_vicious_frenzy.3d16eef8.jpg";